import React from 'react';
import BaseIcon, { IconProps } from '../Base.icon';

const ComputerSleepIcon = ({ width = 270, height = 270 }: IconProps) => {
  return (
    <BaseIcon width={width} height={height} viewBox="0 0 270 270">
      <path
        d="M202.043 217.43C224.012 199.42 238.033 172.062 238.033 141.425C238.033 87.189 194.101 43.2219 139.907 43.2219C85.7136 43.2219 41.7811 87.189 41.7811 141.425C41.7811 172.063 55.8024 199.421 77.7713 217.43C96.1272 217.079 117.324 216.878 139.907 216.878C162.49 216.878 183.688 217.079 202.043 217.43Z"
        fill="white"
      />
      <path
        opacity="0.2"
        d="M219.108 156.313C219.059 156.315 219.01 156.322 218.962 156.326V132.08C218.962 126.993 214.827 122.855 209.743 122.855H87.9464C82.8634 122.855 78.7279 126.993 78.7279 132.08V140.313C78.7236 140.312 78.7185 140.311 78.7141 140.31C78.634 140.293 78.5538 140.278 78.4736 140.262C78.3951 140.247 78.3158 140.232 78.2373 140.219C78.1597 140.207 78.0812 140.197 78.0036 140.187C77.7743 140.157 77.5432 140.133 77.3104 140.12L76.6473 137.136L75.9782 140.151C75.7298 140.174 75.4806 140.209 75.2306 140.253C75.1849 140.261 75.1392 140.267 75.0935 140.276C74.8814 140.316 74.6684 140.366 74.4563 140.419C74.3718 140.441 74.2873 140.46 74.2028 140.484C73.669 140.632 73.1335 140.823 72.6015 141.062L70.99 138.646L71.384 141.692C70.3545 142.299 69.3973 143.06 68.5342 143.948L65.7086 142.421L67.634 144.963C66.9545 145.804 66.3509 146.731 65.8431 147.732C65.7801 147.856 65.7215 147.981 65.662 148.105L63.0674 146.574L65.1696 149.252C64.8489 150.09 64.6014 150.942 64.435 151.796C63.7409 151.561 63.0286 151.374 62.3026 151.235L62.313 148.463L61.2403 151.067C60.6031 150.989 59.9572 150.947 59.3019 150.947C59.0139 150.947 58.7276 150.956 58.4422 150.972C58.3526 150.217 58.218 149.452 58.043 148.683L60.4263 148.086L57.7197 147.409C57.4817 146.579 57.1919 145.745 56.8557 144.915L59.2942 143.178L56.3875 143.822C56.2866 143.602 56.1796 143.384 56.0719 143.166C57.4334 142.381 58.7432 141.324 59.9245 140.032L61.9353 141.668L60.6583 139.173C61.2687 138.416 61.8378 137.596 62.3483 136.711C62.6527 136.183 62.9252 135.649 63.1726 135.111L65.7077 135.25L63.6176 134.064C64.3074 132.29 64.6894 130.501 64.7764 128.8L67.5943 127.699L64.7877 127.559C64.7316 125.957 64.3988 124.463 63.7995 123.171L66.0854 120.526L63.1054 121.942C62.4673 121.001 61.6533 120.217 60.6643 119.645C60.2202 119.389 59.7572 119.185 59.2795 119.028L59.295 115.995L58.0292 118.741C56.622 118.536 55.1268 118.704 53.6377 119.209L52.5029 116.748L52.5176 119.648C51.1725 120.256 49.854 121.134 48.6339 122.243L46.4671 120.902L47.7975 123.055C46.8663 124.022 46.0092 125.132 45.2616 126.369L43.0602 125.565C43.0499 125.628 43.0387 125.691 43.0292 125.754L44.696 127.364C44.1148 128.465 43.6587 129.588 43.3215 130.707C43.0163 130.581 42.711 130.464 42.4049 130.355C41.9971 133.99 41.7806 137.682 41.7806 141.425C41.7806 172.063 55.802 199.421 77.7708 217.43C96.1268 217.079 117.324 216.878 139.907 216.878C162.489 216.878 183.687 217.079 202.043 217.43C220.56 202.25 233.429 180.428 237.017 155.599L219.108 156.313Z"
        fill="#404851"
      />
      <path
        opacity="0.1"
        d="M266.471 221.168C266.471 218.799 209.806 216.879 139.906 216.879C70.0067 216.879 13.3419 218.799 13.3419 221.168C13.3419 222.537 32.2773 223.756 61.7582 224.542C68.12 226.077 92.7843 227.222 122.242 227.222C146.91 227.222 168.216 226.419 178.229 225.256C229.393 224.706 266.471 223.083 266.471 221.168Z"
        fill="#404851"
      />
      <path
        d="M56.0861 135.39C59.6191 129.266 59.0504 122.318 54.8159 119.871C50.5813 117.424 44.2844 120.405 40.7513 126.529C37.2183 132.654 37.787 139.602 42.0216 142.048C46.2561 144.495 52.553 141.514 56.0861 135.39Z"
        fill="#88BE4A"
      />
      <path
        d="M45.3246 144.04C43.938 144.04 42.6282 143.703 41.4599 143.028C39.0809 141.653 37.6211 139.072 37.3494 135.759C37.0908 132.601 37.9522 129.122 39.775 125.962C41.5978 122.803 44.1777 120.317 47.0405 118.961C50.0429 117.54 53.0065 117.514 55.3855 118.889C57.7645 120.263 59.2243 122.845 59.4959 126.157C59.7546 129.316 58.8932 132.795 57.0704 135.954C55.2475 139.114 52.6676 141.6 49.8049 142.955C48.2778 143.679 46.7602 144.04 45.3246 144.04ZM51.5156 120.145C50.4111 120.145 49.2229 120.433 48.0079 121.008C45.5574 122.168 43.3293 124.33 41.7349 127.094C40.1397 129.858 39.3835 132.869 39.6051 135.574C39.8138 138.123 40.8744 140.073 42.5912 141.066C44.3079 142.057 46.5257 142.001 48.8366 140.908C51.2871 139.748 53.5152 137.586 55.1096 134.822C56.7048 132.058 57.461 129.047 57.2394 126.343C57.0307 123.793 55.9701 121.843 54.2533 120.851C53.4394 120.38 52.5116 120.145 51.5156 120.145ZM40.7554 126.528H40.7597H40.7554Z"
        fill="#404851"
      />
      <g opacity="0.4">
        <path
          opacity="0.4"
          d="M42.1122 128.227C45.3276 122.654 50.9435 119.853 54.6306 121.983C55.7041 122.604 56.4957 123.576 57.0018 124.778C56.5681 123.052 55.6472 121.655 54.2538 120.85C50.5667 118.72 44.9508 121.521 41.7354 127.094C39.4564 131.044 38.9882 135.342 40.2204 138.27C39.5055 135.429 40.1117 131.694 42.1122 128.227Z"
          fill="white"
        />
      </g>
      <path
        d="M45.4217 174.69C46.3288 171.055 42.8096 167.045 37.5615 165.734C32.3133 164.422 27.3235 166.305 26.4165 169.94C25.5094 173.575 29.0286 177.585 34.2767 178.897C39.5249 180.208 44.5146 178.325 45.4217 174.69Z"
        fill="#88BE4A"
      />
      <path
        d="M37.6037 180.252C36.4396 180.252 35.2402 180.104 34.0468 179.805C28.3024 178.369 24.4679 173.838 25.4992 169.704C26.0148 167.636 27.6229 165.999 30.0261 165.092C32.3094 164.23 35.066 164.131 37.7882 164.811C43.5326 166.247 47.3671 170.778 46.3359 174.912C45.8202 176.98 44.2121 178.617 41.809 179.524C40.5268 180.009 39.0945 180.252 37.6037 180.252ZM34.5038 177.974C36.8578 178.561 39.2153 178.485 41.1433 177.758C42.9497 177.075 44.144 175.903 44.5053 174.454C45.2848 171.33 42.0659 167.825 37.3312 166.641C34.9764 166.054 32.6189 166.13 30.6917 166.857C28.8853 167.54 27.6911 168.713 27.3298 170.161C26.5503 173.286 29.7683 176.791 34.5038 177.974Z"
        fill="#404851"
      />
      <g opacity="0.4">
        <path
          opacity="0.4"
          d="M28.4614 170.917C28.8226 169.468 30.0169 168.295 31.8233 167.613C32.8943 167.209 34.0971 167.006 35.3595 167.006C36.3692 167.006 37.4169 167.136 38.4628 167.397C39.6364 167.691 40.7332 168.131 41.7075 168.69C40.4874 167.768 38.9888 167.057 37.3315 166.642C36.2856 166.381 35.2379 166.25 34.2282 166.25C32.9667 166.25 31.763 166.454 30.692 166.858C28.8847 167.54 27.6913 168.713 27.3301 170.161C26.7523 172.478 28.3734 175.003 31.1801 176.636C29.0856 175.037 27.9664 172.901 28.4614 170.917Z"
          fill="white"
        />
      </g>
      <path
        d="M78.0017 155.851C80.9472 150.05 79.6191 143.457 75.0352 141.126C70.4514 138.795 64.3476 141.609 61.4021 147.41C58.4566 153.211 59.7847 159.804 64.3685 162.135C68.9524 164.466 75.0561 161.653 78.0017 155.851Z"
        fill="#88BE4A"
      />
      <path
        d="M67.8486 163.897C66.4811 163.897 65.1575 163.589 63.9434 162.971C61.4644 161.71 59.758 159.325 59.1397 156.254C58.5379 153.266 59.0432 149.97 60.5633 146.976C63.7399 140.72 70.4242 137.716 75.4642 140.278C80.5042 142.841 82.0209 150.016 78.8443 156.272C77.3241 159.267 74.9632 161.618 72.1962 162.894C70.7459 163.563 69.2722 163.897 67.8486 163.897ZM71.5555 141.243C68.0659 141.243 64.3194 143.744 62.2448 147.831C60.916 150.448 60.4693 153.307 60.9884 155.882C61.4903 158.374 62.8432 160.294 64.7979 161.288C66.7527 162.282 69.0998 162.243 71.4072 161.18C73.7897 160.082 75.8341 158.035 77.1629 155.417C79.8678 150.089 78.7227 144.053 74.6105 141.961C73.6517 141.474 72.6153 141.243 71.5555 141.243Z"
        fill="#404851"
      />
      <g opacity="0.2">
        <path
          opacity="0.2"
          d="M72.8765 140.533C72.8765 140.533 73.631 156.013 59.6735 154.125L65.7093 163.564C65.7093 163.564 73.2541 162.809 75.5176 159.033C75.5167 159.033 76.4204 142.749 72.8765 140.533Z"
          fill="#404851"
        />
      </g>
      <g opacity="0.4">
        <path
          opacity="0.4"
          d="M61.3627 157.014C60.8437 154.44 61.2903 151.582 62.6191 148.965C63.9478 146.348 65.9923 144.301 68.3747 143.202C69.5698 142.652 70.7753 142.375 71.9316 142.375C73.0077 142.375 74.0416 142.615 74.984 143.093C76.5059 143.868 77.6208 145.183 78.2856 146.802C77.7226 144.667 76.4706 142.909 74.6072 141.96C73.6656 141.481 72.6318 141.242 71.5548 141.242C70.3985 141.242 69.193 141.519 67.9979 142.069C65.6155 143.168 63.571 145.214 62.2423 147.832C60.9135 150.449 60.4668 153.308 60.9859 155.881C61.1075 156.486 61.28 157.055 61.4981 157.587C61.4481 157.399 61.4024 157.209 61.3627 157.014Z"
          fill="white"
        />
      </g>
      <path
        d="M47.7354 162.441C53.708 158.224 53.6717 147.886 47.6543 139.35C41.637 130.815 31.9172 127.314 25.9446 131.532C19.9721 135.749 20.0084 146.087 26.0257 154.622C32.0431 163.157 41.7628 166.658 47.7354 162.441Z"
        fill="#88BE4A"
      />
      <path
        d="M41.8738 165.333C36.1423 165.333 29.6063 161.649 25.1061 155.267C22.0632 150.951 20.3783 146.045 20.3619 141.454C20.3447 136.712 22.0968 132.857 25.2958 130.598C31.7689 126.028 42.2152 129.657 48.5831 138.688C51.626 143.004 53.3109 147.91 53.3273 152.501C53.3445 157.243 51.5924 161.098 48.3934 163.357C46.4947 164.698 44.2528 165.333 41.8738 165.333ZM31.8749 130.859C29.9374 130.859 28.1292 131.37 26.6004 132.448C24.0223 134.269 22.6107 137.464 22.6245 141.445C22.6392 145.576 24.1775 150.021 26.9557 153.961C32.6044 161.971 41.6358 165.357 47.0879 161.506C49.6661 159.685 51.0776 156.491 51.0638 152.509C51.0492 148.378 49.5109 143.933 46.7327 139.994C42.6679 134.228 36.8494 130.859 31.8749 130.859Z"
        fill="#404851"
      />
      <g opacity="0.4">
        <path
          opacity="0.4"
          d="M29.2164 155.094C23.5677 147.083 23.4081 137.433 28.8611 133.581C31.7264 131.558 35.5799 131.534 39.4118 133.128C34.8797 130.469 30.0303 130.024 26.5977 132.448C21.1447 136.299 21.3042 145.949 26.9529 153.961C29.6337 157.762 33.0759 160.519 36.5361 161.958C33.8674 160.393 31.3091 158.062 29.2164 155.094Z"
          fill="white"
        />
      </g>
      <path
        d="M54.0198 189.631C63.3046 189.631 70.8314 181.056 70.8314 170.477C70.8314 159.899 63.3046 151.324 54.0198 151.324C44.735 151.324 37.2081 159.899 37.2081 170.477C37.2081 181.056 44.735 189.631 54.0198 189.631Z"
        fill="#88BE4A"
      />
      <path
        d="M54.0196 190.764C44.1259 190.764 36.0767 181.664 36.0767 170.477C36.0767 159.292 44.1259 150.191 54.0196 150.191C63.9132 150.191 71.9625 159.292 71.9625 170.477C71.9634 181.664 63.9141 190.764 54.0196 190.764ZM54.0196 152.457C45.3736 152.457 38.3401 160.541 38.3401 170.477C38.3401 180.414 45.3736 188.499 54.0196 188.499C62.6655 188.499 69.6991 180.414 69.6991 170.477C69.6999 160.541 62.6655 152.457 54.0196 152.457Z"
        fill="#404851"
      />
      <g opacity="0.4">
        <path
          opacity="0.4"
          d="M54.0205 152.456C52.609 152.456 51.2414 152.675 49.9394 153.079C46.9784 153.998 44.3614 155.888 42.3661 158.437C39.8656 161.63 38.3411 165.853 38.3411 170.476C38.3411 176.205 40.6813 181.313 44.3166 184.616C41.3349 181.333 39.4724 176.717 39.4724 171.609C39.4724 167.08 40.9365 162.939 43.3457 159.77C44.4416 160.003 46.242 159.169 47.801 157.609C48.7581 156.651 49.4419 155.601 49.773 154.68C51.451 153.973 53.2626 153.588 55.151 153.588C58.813 153.588 62.1828 155.042 64.8549 157.469C62.0379 154.368 58.2206 152.456 54.0205 152.456Z"
          fill="white"
        />
      </g>
      <path
        d="M52.9297 124.629C53.3202 124.629 53.6368 124.312 53.6368 123.921C53.6368 123.531 53.3202 123.214 52.9297 123.214C52.5392 123.214 52.2227 123.531 52.2227 123.921C52.2227 124.312 52.5392 124.629 52.9297 124.629Z"
        fill="#404851"
      />
      <path
        d="M46.798 126.328C47.1885 126.328 47.5051 126.011 47.5051 125.621C47.5051 125.23 47.1885 124.913 46.798 124.913C46.4075 124.913 46.0909 125.23 46.0909 125.621C46.0909 126.011 46.4075 126.328 46.798 126.328Z"
        fill="#404851"
      />
      <path
        d="M53.3054 130.576C53.6959 130.576 54.0125 130.259 54.0125 129.868C54.0125 129.477 53.6959 129.16 53.3054 129.16C52.915 129.16 52.5984 129.477 52.5984 129.868C52.5984 130.259 52.915 130.576 53.3054 130.576Z"
        fill="#404851"
      />
      <path
        d="M29.918 135.861C30.3085 135.861 30.6251 135.544 30.6251 135.154C30.6251 134.763 30.3085 134.446 29.918 134.446C29.5275 134.446 29.2109 134.763 29.2109 135.154C29.2109 135.544 29.5275 135.861 29.918 135.861Z"
        fill="#404851"
      />
      <path
        d="M26.5233 144.922C26.9138 144.922 27.2304 144.605 27.2304 144.215C27.2304 143.824 26.9138 143.507 26.5233 143.507C26.1328 143.507 25.8163 143.824 25.8163 144.215C25.8163 144.605 26.1328 144.922 26.5233 144.922Z"
        fill="#404851"
      />
      <path
        d="M38.9711 138.126C39.3616 138.126 39.6782 137.809 39.6782 137.419C39.6782 137.028 39.3616 136.711 38.9711 136.711C38.5806 136.711 38.264 137.028 38.264 137.419C38.264 137.809 38.5806 138.126 38.9711 138.126Z"
        fill="#404851"
      />
      <path
        d="M35.1263 144.677C35.5168 144.677 35.8334 144.36 35.8334 143.969C35.8334 143.578 35.5168 143.262 35.1263 143.262C34.7358 143.262 34.4193 143.578 34.4193 143.969C34.4193 144.36 34.7358 144.677 35.1263 144.677Z"
        fill="#404851"
      />
      <path
        d="M30.6726 153.983C31.0631 153.983 31.3797 153.666 31.3797 153.275C31.3797 152.885 31.0631 152.568 30.6726 152.568C30.2821 152.568 29.9656 152.885 29.9656 153.275C29.9656 153.666 30.2821 153.983 30.6726 153.983Z"
        fill="#404851"
      />
      <path
        d="M45.3845 145.3C45.775 145.3 46.0916 144.983 46.0916 144.592C46.0916 144.201 45.775 143.885 45.3845 143.885C44.9941 143.885 44.6775 144.201 44.6775 144.592C44.6775 144.983 44.9941 145.3 45.3845 145.3Z"
        fill="#404851"
      />
      <path
        d="M40.1047 151.718C40.4952 151.718 40.8118 151.401 40.8118 151.01C40.8118 150.619 40.4952 150.302 40.1047 150.302C39.7142 150.302 39.3976 150.619 39.3976 151.01C39.3976 151.401 39.7142 151.718 40.1047 151.718Z"
        fill="#404851"
      />
      <path
        d="M30.6726 172.105C31.0631 172.105 31.3797 171.788 31.3797 171.397C31.3797 171.006 31.0631 170.69 30.6726 170.69C30.2821 170.69 29.9656 171.006 29.9656 171.397C29.9656 171.788 30.2821 172.105 30.6726 172.105Z"
        fill="#404851"
      />
      <path
        d="M34.0671 169.84C34.4576 169.84 34.7742 169.523 34.7742 169.132C34.7742 168.741 34.4576 168.424 34.0671 168.424C33.6766 168.424 33.36 168.741 33.36 169.132C33.36 169.523 33.6766 169.84 34.0671 169.84Z"
        fill="#404851"
      />
      <path
        d="M34.4442 175.503C34.8347 175.503 35.1513 175.186 35.1513 174.796C35.1513 174.405 34.8347 174.088 34.4442 174.088C34.0537 174.088 33.7372 174.405 33.7372 174.796C33.7372 175.186 34.0537 175.503 34.4442 175.503Z"
        fill="#404851"
      />
      <path
        d="M47.5542 132.18C47.9447 132.18 48.2613 131.863 48.2613 131.472C48.2613 131.081 47.9447 130.765 47.5542 130.765C47.1637 130.765 46.8472 131.081 46.8472 131.472C46.8472 131.863 47.1637 132.18 47.5542 132.18Z"
        fill="#404851"
      />
      <path
        d="M53.3054 157.758C53.6959 157.758 54.0125 157.442 54.0125 157.051C54.0125 156.66 53.6959 156.343 53.3054 156.343C52.915 156.343 52.5984 156.66 52.5984 157.051C52.5984 157.442 52.915 157.758 53.3054 157.758Z"
        fill="#404851"
      />
      <path
        d="M70.6587 144.545C71.0492 144.545 71.3657 144.228 71.3657 143.837C71.3657 143.447 71.0492 143.13 70.6587 143.13C70.2682 143.13 69.9516 143.447 69.9516 143.837C69.9516 144.228 70.2682 144.545 70.6587 144.545Z"
        fill="#404851"
      />
      <path
        d="M70.6587 150.586C71.0492 150.586 71.3657 150.269 71.3657 149.878C71.3657 149.487 71.0492 149.171 70.6587 149.171C70.2682 149.171 69.9516 149.487 69.9516 149.878C69.9516 150.269 70.2682 150.586 70.6587 150.586Z"
        fill="#404851"
      />
      <path
        d="M64.6243 149.453C65.0148 149.453 65.3314 149.136 65.3314 148.745C65.3314 148.354 65.0148 148.037 64.6243 148.037C64.2338 148.037 63.9172 148.354 63.9172 148.745C63.9172 149.136 64.2338 149.453 64.6243 149.453Z"
        fill="#404851"
      />
      <path
        d="M73.3016 157.758C73.6921 157.758 74.0086 157.442 74.0086 157.051C74.0086 156.66 73.6921 156.343 73.3016 156.343C72.9111 156.343 72.5945 156.66 72.5945 157.051C72.5945 157.442 72.9111 157.758 73.3016 157.758Z"
        fill="#404851"
      />
      <path
        d="M44.6295 162.289C45.02 162.289 45.3366 161.972 45.3366 161.581C45.3366 161.191 45.02 160.874 44.6295 160.874C44.239 160.874 43.9225 161.191 43.9225 161.581C43.9225 161.972 44.239 162.289 44.6295 162.289Z"
        fill="#404851"
      />
      <path
        d="M63.1148 162.289C63.5054 162.289 63.8219 161.972 63.8219 161.581C63.8219 161.191 63.5054 160.874 63.1148 160.874C62.7243 160.874 62.4078 161.191 62.4078 161.581C62.4078 161.972 62.7243 162.289 63.1148 162.289Z"
        fill="#404851"
      />
      <path
        d="M53.3054 166.819C53.6959 166.819 54.0125 166.502 54.0125 166.112C54.0125 165.721 53.6959 165.404 53.3054 165.404C52.915 165.404 52.5984 165.721 52.5984 166.112C52.5984 166.502 52.915 166.819 53.3054 166.819Z"
        fill="#404851"
      />
      <path
        d="M43.8765 172.105C44.267 172.105 44.5836 171.788 44.5836 171.397C44.5836 171.006 44.267 170.689 43.8765 170.689C43.486 170.689 43.1694 171.006 43.1694 171.397C43.1694 171.788 43.486 172.105 43.8765 172.105Z"
        fill="#404851"
      />
      <path
        d="M64.2472 171.728C64.6377 171.728 64.9542 171.411 64.9542 171.02C64.9542 170.629 64.6377 170.313 64.2472 170.313C63.8567 170.313 63.5401 170.629 63.5401 171.02C63.5401 171.411 63.8567 171.728 64.2472 171.728Z"
        fill="#404851"
      />
      <path
        d="M54.4389 175.125C54.8294 175.125 55.146 174.808 55.146 174.418C55.146 174.027 54.8294 173.71 54.4389 173.71C54.0484 173.71 53.7319 174.027 53.7319 174.418C53.7319 174.808 54.0484 175.125 54.4389 175.125Z"
        fill="#404851"
      />
      <path
        d="M45.7617 181.544C46.1522 181.544 46.4688 181.227 46.4688 180.836C46.4688 180.445 46.1522 180.128 45.7617 180.128C45.3712 180.128 45.0547 180.445 45.0547 180.836C45.0547 181.227 45.3712 181.544 45.7617 181.544Z"
        fill="#404851"
      />
      <path
        d="M61.9828 180.789C62.3733 180.789 62.6898 180.472 62.6898 180.081C62.6898 179.69 62.3733 179.373 61.9828 179.373C61.5923 179.373 61.2757 179.69 61.2757 180.081C61.2757 180.472 61.5923 180.789 61.9828 180.789Z"
        fill="#404851"
      />
      <path
        d="M48.5101 219.061H57.7786C68.7329 219.061 77.6133 210.174 77.6133 199.211V188.028C77.6133 186.175 76.1121 184.673 74.2608 184.673H32.027C30.1757 184.673 28.6745 186.175 28.6745 188.028V199.211C28.6754 210.175 37.555 219.061 48.5101 219.061Z"
        fill="#404851"
      />
      <path
        d="M57.7791 220.194H48.5106C36.9502 220.194 27.5446 210.781 27.5446 199.212V188.029C27.5446 185.555 29.5562 183.542 32.0283 183.542H74.2622C76.7343 183.542 78.746 185.555 78.746 188.029V199.212C78.7451 210.781 69.3395 220.194 57.7791 220.194ZM32.0275 185.806C30.8031 185.806 29.8071 186.803 29.8071 188.028V199.211C29.8071 209.532 38.197 217.928 48.5097 217.928H57.7782C68.0909 217.928 76.4808 209.532 76.4808 199.211V188.028C76.4808 186.803 75.4849 185.806 74.2605 185.806H32.0275Z"
        fill="#404851"
      />
      <g opacity="0.2">
        <path
          opacity="0.2"
          d="M74.2607 184.674H64.9164C64.4921 188.33 60.004 220.058 32.7141 211.213C33.0194 211.614 33.3401 212.003 33.6738 212.379L41.06 217.608C43.3605 218.543 45.874 219.061 48.51 219.061H57.7785C68.7328 219.061 77.6132 210.174 77.6132 199.211V188.028C77.6132 186.176 76.112 184.674 74.2607 184.674Z"
          fill="#404851"
        />
      </g>
      <g opacity="0.5">
        <path
          opacity="0.5"
          d="M32.0706 200.722V189.539C32.0706 188.313 33.0665 187.317 34.2909 187.317H76.3627C76.0652 186.44 75.2365 185.807 74.2613 185.807H32.0275C30.803 185.807 29.8071 186.803 29.8071 188.029V199.212C29.8071 206.193 33.6485 212.289 39.324 215.507C34.9152 212.079 32.0706 206.728 32.0706 200.722Z"
          fill="white"
        />
      </g>
      <g opacity="0.2">
        <path
          opacity="0.2"
          d="M41.9416 133.36C40.9017 132.914 43.4505 154.881 27.2296 155.635C27.2296 155.635 33.4543 164.507 38.358 162.997C38.358 162.997 40.9982 153.558 52.6932 150.915C52.6932 150.916 48.5439 136.192 41.9416 133.36Z"
          fill="#404851"
        />
      </g>
      <g opacity="0.2">
        <path
          opacity="0.2"
          d="M58.5397 123.921C58.5397 123.921 52.8815 135.247 40.0544 129.207L39.1215 131.761C39.1215 131.761 47.0336 136.569 49.2971 141.1C49.2979 141.1 58.619 136.079 58.5397 123.921Z"
          fill="#404851"
        />
      </g>
      <g opacity="0.2">
        <path
          opacity="0.2"
          d="M35.1502 165.829C35.1502 165.829 34.2897 176.833 27.6054 174.89C27.6054 174.89 33.4524 180.741 38.7338 178.854C38.7338 178.854 35.4581 169.697 37.85 165.781C37.85 165.78 35.2391 165.736 35.1502 165.829Z"
          fill="#404851"
        />
      </g>
      <path
        d="M40.0324 127.205L37.4146 124.677L40.8326 125.925C41.2327 126.071 41.4388 126.515 41.2931 126.915C41.1474 127.316 40.7042 127.522 40.3041 127.376C40.1997 127.337 40.1066 127.277 40.0324 127.205Z"
        fill="#404851"
      />
      <path
        d="M42.9164 122.945L41.1867 120.146L43.9839 121.877C44.3478 122.102 44.4607 122.58 44.2357 122.944C44.0106 123.309 43.5329 123.422 43.169 123.196C43.063 123.133 42.9776 123.044 42.9164 122.945Z"
        fill="#404851"
      />
      <path
        d="M47.2252 115.994L48.7161 119.228C48.8946 119.615 48.7256 120.075 48.3384 120.253C47.9512 120.432 47.4925 120.263 47.314 119.875C47.2666 119.773 47.2442 119.661 47.2433 119.555L47.2252 115.994Z"
        fill="#404851"
      />
      <path
        d="M54.0124 115.239L53.9943 118.8C53.9918 119.227 53.6451 119.571 53.2183 119.569C52.7923 119.567 52.4483 119.219 52.45 118.792C52.4509 118.679 52.4767 118.569 52.5207 118.473L54.0124 115.239Z"
        fill="#404851"
      />
      <path
        d="M28.3626 125.432L29.4913 129.516C29.6043 129.924 29.3646 130.347 28.9567 130.46C28.5488 130.573 28.1263 130.333 28.0134 129.925C27.9884 129.835 27.9815 129.741 27.9884 129.652L28.3626 125.432Z"
        fill="#404851"
      />
      <path
        d="M20.439 130.718L23.9096 132.379C24.2933 132.563 24.4554 133.022 24.2718 133.406C24.0881 133.79 23.6294 133.952 23.2457 133.769C23.1525 133.724 23.0698 133.66 23.0042 133.587L20.439 130.718Z"
        fill="#404851"
      />
      <path
        d="M17.4186 136.381L21.767 136.784C22.1887 136.823 22.4982 137.197 22.4586 137.619C22.4198 138.041 22.0464 138.351 21.6247 138.311C21.5351 138.302 21.4471 138.277 21.3695 138.241L17.4186 136.381Z"
        fill="#404851"
      />
      <path
        d="M17.043 143.554L21.1922 142.798C21.6087 142.722 22.0079 142.999 22.0838 143.416C22.1597 143.833 21.8829 144.233 21.4664 144.309C21.3742 144.326 21.2793 144.324 21.1922 144.309L17.043 143.554Z"
        fill="#404851"
      />
      <path
        d="M18.9271 151.104L22.3624 148.541C22.7021 148.288 23.1824 148.358 23.4351 148.697C23.6877 149.037 23.6179 149.517 23.279 149.771C23.2048 149.826 23.1212 149.867 23.0376 149.892L18.9271 151.104Z"
        fill="#404851"
      />
      <path
        d="M23.0812 157.145L25.1886 153.968C25.424 153.614 25.9017 153.517 26.2553 153.753C26.6088 153.988 26.7062 154.466 26.4708 154.82C26.4131 154.907 26.3372 154.981 26.2553 155.036L23.0812 157.145Z"
        fill="#404851"
      />
      <path
        d="M28.3615 162.808L29.5885 159.043C29.7204 158.639 30.1541 158.418 30.5576 158.55C30.9612 158.682 31.1819 159.117 31.05 159.52C31.019 159.616 30.9689 159.704 30.9077 159.777L28.3615 162.808Z"
        fill="#404851"
      />
      <path
        d="M34.3934 125.809L34.7658 129.291C34.8115 129.715 34.5046 130.097 34.0795 130.141C33.6553 130.187 33.2742 129.88 33.2293 129.455C33.2173 129.341 33.2319 129.226 33.2664 129.124L34.3934 125.809Z"
        fill="#404851"
      />
      <path
        d="M43.4538 130.718L43.0157 133.658C42.9519 134.084 42.5553 134.378 42.1293 134.315C41.7033 134.251 41.4093 133.854 41.4731 133.428C41.4938 133.291 41.5507 133.165 41.6292 133.063L43.4538 130.718Z"
        fill="#404851"
      />
      <path
        d="M48.7304 134.493L46.6575 138.01C46.442 138.376 45.9712 138.497 45.6064 138.282C45.2417 138.067 45.1201 137.595 45.3348 137.23C45.384 137.146 45.4495 137.073 45.5219 137.016L48.7304 134.493Z"
        fill="#404851"
      />
      <path
        d="M55.1461 147.33L52.1281 148.085C51.7116 148.189 51.2891 147.935 51.1848 147.519C51.0804 147.102 51.3339 146.679 51.7504 146.575C51.8772 146.543 52.0082 146.545 52.1281 146.575L55.1461 147.33Z"
        fill="#404851"
      />
      <path
        d="M57.7864 145.819L61.3009 147.894C61.6665 148.11 61.7873 148.581 61.5726 148.946C61.3579 149.311 60.8862 149.433 60.5215 149.217C60.4378 149.168 60.3645 149.102 60.3076 149.03L57.7864 145.819Z"
        fill="#404851"
      />
      <path
        d="M57.0309 147.707L57.0163 151.631C57.0145 152.055 56.6688 152.399 56.2445 152.397C55.8203 152.395 55.4771 152.05 55.4788 151.625C55.4788 151.523 55.5004 151.423 55.5366 151.334L57.0309 147.707Z"
        fill="#404851"
      />
      <path
        d="M65.7081 151.482L64.4621 154.903C64.3164 155.303 63.8732 155.509 63.4731 155.364C63.073 155.218 62.8669 154.774 63.0127 154.374C63.0506 154.27 63.111 154.177 63.1825 154.102L65.7081 151.482Z"
        fill="#404851"
      />
      <path
        d="M70.9895 156.013L67.6051 158.925C67.2843 159.201 66.8014 159.165 66.5255 158.844C66.2495 158.523 66.2858 158.04 66.6065 157.764C66.6738 157.706 66.7505 157.661 66.8281 157.631L70.9895 156.013Z"
        fill="#404851"
      />
      <path
        d="M75.1399 166.962L71.2485 169.181C70.8812 169.391 70.4138 169.262 70.2043 168.895C69.9948 168.527 70.1232 168.059 70.4906 167.85C70.5673 167.806 70.6509 167.777 70.7329 167.762L75.1399 166.962Z"
        fill="#404851"
      />
      <path
        d="M75.1379 174.959L70.4757 174.878C70.0532 174.87 69.7169 174.521 69.7247 174.099C69.7324 173.676 70.0808 173.34 70.5024 173.348C70.5869 173.349 70.6706 173.366 70.7456 173.392L75.1379 174.959Z"
        fill="#404851"
      />
      <path
        d="M72.1202 180.93L69.0411 179.656C68.6462 179.493 68.4574 179.039 68.6212 178.644C68.7842 178.248 69.2377 178.06 69.6326 178.224C69.7447 178.27 69.843 178.343 69.918 178.428L72.1202 180.93Z"
        fill="#404851"
      />
      <path
        d="M46.0916 149.217L47.9394 152.376C48.155 152.744 48.0308 153.217 47.6635 153.432C47.2962 153.647 46.8236 153.523 46.6089 153.155C46.5537 153.06 46.5201 152.956 46.508 152.853L46.0916 149.217Z"
        fill="#404851"
      />
      <path
        d="M40.6814 152.292L43.6269 154.367C43.9752 154.613 44.0589 155.095 43.814 155.443C43.5691 155.792 43.0871 155.876 42.7387 155.63C42.6473 155.567 42.5732 155.483 42.5189 155.393L40.6814 152.292Z"
        fill="#404851"
      />
      <path
        d="M36.2854 157.901L40.2742 158.31C40.6959 158.353 41.0037 158.731 40.9597 159.153C40.9166 159.575 40.5389 159.882 40.1173 159.839C40.0181 159.828 39.9233 159.799 39.8405 159.756L36.2854 157.901Z"
        fill="#404851"
      />
      <path
        d="M60.4279 141.666L63.5596 143.358C63.9347 143.561 64.0744 144.03 63.8726 144.405C63.67 144.781 63.2018 144.92 62.8267 144.719C62.7275 144.665 62.6422 144.59 62.5784 144.505L60.4279 141.666Z"
        fill="#404851"
      />
      <path
        d="M65.7092 137.891L67.5475 140.646C67.7855 141.003 67.689 141.484 67.3337 141.721C66.9784 141.959 66.4964 141.863 66.2593 141.507C66.1912 141.405 66.1506 141.289 66.1351 141.175L65.7092 137.891Z"
        fill="#404851"
      />
      <path
        d="M71.3667 136.381L72.1212 139.779C72.2134 140.196 71.9513 140.609 71.534 140.701C71.1175 140.794 70.7045 140.531 70.6122 140.115C70.5872 140.002 70.5889 139.885 70.6122 139.779L71.3667 136.381Z"
        fill="#404851"
      />
      <path
        d="M54.0134 142.421L50.9248 144.622C50.5782 144.869 50.0979 144.787 49.8513 144.44C49.6047 144.094 49.6857 143.613 50.0323 143.366C50.1177 143.305 50.216 143.263 50.3126 143.242L54.0134 142.421Z"
        fill="#404851"
      />
      <path
        d="M54.9838 137.647L56.6548 140.911L53.8112 138.598C53.4809 138.328 53.4309 137.843 53.6991 137.512C53.9681 137.182 54.4535 137.132 54.7838 137.4C54.8683 137.469 54.9364 137.556 54.9838 137.647Z"
        fill="#404851"
      />
      <path
        d="M57.5558 132.863L60.4289 134.493L57.1316 134.312C56.7039 134.289 56.3771 133.923 56.4004 133.495C56.4237 133.067 56.7893 132.74 57.217 132.763C57.3385 132.77 57.4558 132.807 57.5558 132.863Z"
        fill="#404851"
      />
      <path
        d="M62.3121 126.942L58.9553 128.254C58.5586 128.409 58.1111 128.212 57.9559 127.815C57.8007 127.418 57.9973 126.97 58.3939 126.815C58.4974 126.774 58.6086 126.758 58.713 126.763L62.3121 126.942Z"
        fill="#404851"
      />
      <path
        d="M60.8034 119.769L58.4045 122.544C58.126 122.867 57.6388 122.902 57.3172 122.623C56.9956 122.344 56.9602 121.856 57.2387 121.534C57.3103 121.452 57.3991 121.387 57.4914 121.342L60.8034 119.769Z"
        fill="#404851"
      />
      <path
        d="M33.2653 168.849L36.8989 169.265C37.3222 169.313 37.6258 169.696 37.5775 170.119C37.5292 170.543 37.1472 170.847 36.7238 170.798C36.6152 170.786 36.5108 170.749 36.422 170.697L33.2653 168.849Z"
        fill="#404851"
      />
      <path
        d="M22.7027 167.716L26.4639 168.944C26.8674 169.076 27.0882 169.51 26.9563 169.914C26.8243 170.318 26.3906 170.539 25.9871 170.407C25.8914 170.375 25.8034 170.325 25.731 170.264L22.7027 167.716Z"
        fill="#404851"
      />
      <path
        d="M26.8517 163.941L29.3178 165.723C29.6661 165.975 29.7455 166.462 29.4937 166.811C29.2419 167.16 28.7547 167.239 28.4064 166.987C28.2977 166.909 28.2132 166.804 28.1589 166.691L26.8517 163.941Z"
        fill="#404851"
      />
      <path
        d="M23.0812 174.134L26.238 172.285C26.6053 172.069 27.0778 172.194 27.2925 172.561C27.5072 172.929 27.3839 173.402 27.0166 173.617C26.9217 173.672 26.8166 173.706 26.7148 173.718L23.0812 174.134Z"
        fill="#404851"
      />
      <path
        d="M25.7196 178.287L27.9218 175.785C28.2047 175.464 28.6944 175.433 29.0152 175.715C29.336 175.998 29.367 176.488 29.0842 176.809C29.004 176.9 28.904 176.97 28.7988 177.013L25.7196 178.287Z"
        fill="#404851"
      />
      <path
        d="M31.0009 181.685L31.8545 178.668C31.9718 178.254 32.4012 178.013 32.8142 178.131C33.2272 178.248 33.4669 178.678 33.3505 179.091C33.3152 179.216 33.2488 179.329 33.1651 179.417L31.0009 181.685Z"
        fill="#404851"
      />
      <path
        d="M34.3954 176.4L37.1487 174.56C37.5048 174.322 37.986 174.418 38.2231 174.774C38.4611 175.13 38.3645 175.612 38.0092 175.85C37.9075 175.918 37.792 175.959 37.6781 175.974L34.3954 176.4Z"
        fill="#404851"
      />
      <path
        d="M36.6613 182.44L39.342 180.254C39.6732 179.984 40.1603 180.034 40.4294 180.366C40.6993 180.697 40.6492 181.185 40.3181 181.454C40.2276 181.527 40.1224 181.578 40.0163 181.605L36.6613 182.44Z"
        fill="#404851"
      />
      <path
        d="M32.8894 161.675L34.3802 164.91C34.5587 165.297 34.3897 165.756 34.0026 165.935C33.6154 166.113 33.1567 165.944 32.9782 165.557C32.9308 165.454 32.9084 165.343 32.9075 165.237L32.8894 161.675Z"
        fill="#404851"
      />
      <g opacity="0.2">
        <path
          opacity="0.2"
          d="M65.7068 156.768C65.7068 156.768 62.5061 186.575 39.6767 179.798L42.4782 184.608H65.8948C65.8956 184.608 76.8352 172.058 65.7068 156.768Z"
          fill="#404851"
        />
      </g>
      <g opacity="0.2">
        <path
          opacity="0.2"
          d="M39.1944 130.078C39.1944 130.078 48.1482 130.843 52.1284 140.156L49.0277 141.728C49.0277 141.728 44.8508 133.83 38.3985 131.235L39.1944 130.078Z"
          fill="#404851"
        />
      </g>
      <g opacity="0.2">
        <path
          opacity="0.2"
          d="M35.5292 162.053C35.5292 162.053 38.5472 149.594 51.3734 148.462L52.1977 151.566C52.1977 151.566 40.2441 152.426 38.7351 163.752L35.5292 162.053Z"
          fill="#404851"
        />
      </g>
      <g opacity="0.2">
        <path
          opacity="0.2"
          d="M60.3845 150.17C60.3845 150.17 70.9283 153.476 72.0898 162.107L70.0454 162.997C70.0454 162.997 67.4051 155.447 59.4826 152.804L60.3845 150.17Z"
          fill="#404851"
        />
      </g>
      <g opacity="0.2">
        <path
          opacity="0.2"
          d="M35.529 165.829C35.529 165.829 32.8008 173.176 36.6172 179.318L39.1134 178.854C39.1134 178.854 34.9642 168.283 37.9821 165.64L35.529 165.829Z"
          fill="#404851"
        />
      </g>
      <path
        d="M213.047 213.096L240.926 213.2L245.464 165.318L208.865 165.183L213.047 213.096Z"
        fill="#B8C5D4"
      />
      <path
        d="M240.926 214.333C240.925 214.333 240.923 214.333 240.921 214.333L213.042 214.229C212.456 214.228 211.969 213.779 211.918 213.196L207.736 165.281C207.709 164.964 207.816 164.651 208.031 164.416C208.246 164.183 208.548 164.05 208.864 164.05C208.866 164.05 208.867 164.05 208.869 164.05L245.467 164.186C245.785 164.187 246.088 164.323 246.302 164.558C246.516 164.794 246.62 165.109 246.59 165.425L242.053 213.307C241.998 213.888 241.51 214.333 240.926 214.333ZM214.084 211.968L239.897 212.063L244.22 166.446L210.1 166.319L214.084 211.968Z"
        fill="#404851"
      />
      <path
        d="M205.817 167.2L248.497 167.359L248.5 166.676C248.51 163.941 246.303 161.716 243.57 161.706L210.787 161.584C208.054 161.574 205.83 163.783 205.82 166.517L205.817 167.2Z"
        fill="#707070"
      />
      <path
        d="M248.498 168.492C248.496 168.492 248.495 168.492 248.493 168.492L205.814 168.333C205.189 168.33 204.684 167.822 204.686 167.196L204.689 166.513C204.695 164.888 205.333 163.362 206.486 162.217C207.638 161.072 209.18 160.454 210.791 160.451L243.574 160.572C245.198 160.578 246.722 161.217 247.866 162.371C249.011 163.524 249.638 165.054 249.632 166.679L249.629 167.363C249.628 167.663 249.507 167.951 249.294 168.163C249.083 168.373 248.796 168.492 248.498 168.492ZM206.98 166.072L247.344 166.222C247.248 165.372 246.872 164.583 246.26 163.967C245.542 163.243 244.585 162.842 243.566 162.838L210.782 162.717C210.777 162.717 210.773 162.717 210.768 162.717C209.754 162.717 208.8 163.11 208.079 163.826C207.463 164.437 207.082 165.222 206.98 166.072Z"
        fill="#404851"
      />
      <g opacity="0.4">
        <path
          opacity="0.4"
          d="M209.588 164.58C210.308 163.864 211.263 163.471 212.277 163.471C212.282 163.471 212.286 163.471 212.291 163.471L245.075 163.593C245.382 163.593 245.679 163.635 245.966 163.705C245.311 163.167 244.477 162.84 243.566 162.837L210.783 162.716C210.777 162.716 210.773 162.716 210.768 162.716C209.754 162.716 208.799 163.109 208.079 163.825C207.464 164.437 207.082 165.222 206.979 166.072L208.659 166.078C208.846 165.52 209.159 165.007 209.588 164.58Z"
          fill="white"
        />
      </g>
      <path
        d="M243.337 161.704L211.018 161.584L211.024 159.645C211.03 158.056 212.286 156.753 213.873 156.689L240.263 155.637C241.951 155.57 243.354 156.925 243.348 158.615L243.337 161.704Z"
        fill="#707070"
      />
      <path
        d="M243.338 162.837C243.336 162.837 243.335 162.837 243.334 162.837L211.014 162.717C210.389 162.714 209.884 162.206 209.886 161.58L209.893 159.641C209.902 157.439 211.63 155.646 213.828 155.558L240.218 154.506C241.346 154.464 242.415 154.868 243.227 155.652C244.04 156.437 244.485 157.491 244.48 158.619L244.469 161.709C244.468 162.009 244.348 162.296 244.135 162.509C243.922 162.719 243.636 162.837 243.338 162.837ZM212.154 160.456L242.21 160.567L242.217 158.611C242.219 158.105 242.019 157.633 241.656 157.282C241.292 156.93 240.811 156.749 240.308 156.768L213.918 157.82C212.933 157.86 212.159 158.663 212.156 159.649L212.154 160.456Z"
        fill="#404851"
      />
      <g opacity="0.4">
        <path
          opacity="0.4"
          d="M212.536 160.405C212.54 159.419 213.314 158.616 214.299 158.576L240.688 157.524C241.192 157.502 241.672 157.687 242.035 158.038C242.086 158.087 242.126 158.143 242.17 158.197C242.092 157.851 241.919 157.536 241.657 157.283C241.293 156.932 240.813 156.747 240.311 156.769L213.921 157.821C212.936 157.86 212.162 158.663 212.159 159.65L212.156 160.456L212.536 160.458V160.405Z"
          fill="white"
        />
      </g>
      <path
        d="M207.224 218.913L246.706 219.06C248.404 219.066 249.786 217.693 249.792 215.993C249.799 214.293 248.427 212.91 246.729 212.904L207.247 212.757C205.549 212.751 204.166 214.124 204.16 215.823C204.153 217.524 205.525 218.907 207.224 218.913Z"
        fill="#BDCAD9"
      />
      <path
        d="M246.717 220.192C246.711 220.192 246.706 220.192 246.7 220.192L207.219 220.046C204.899 220.037 203.019 218.141 203.027 215.82C203.036 213.504 204.922 211.625 207.235 211.625C207.24 211.625 207.245 211.625 207.25 211.625L246.731 211.772C247.855 211.776 248.91 212.218 249.702 213.016C250.493 213.814 250.927 214.873 250.924 215.998C250.92 217.122 250.478 218.178 249.68 218.97C248.887 219.759 247.835 220.192 246.717 220.192ZM207.227 217.78L246.709 217.927C246.711 217.927 246.714 217.927 246.717 217.927C247.233 217.927 247.719 217.727 248.086 217.363C248.454 216.997 248.658 216.509 248.66 215.989C248.664 214.916 247.795 214.04 246.724 214.037L207.242 213.89C207.239 213.89 207.238 213.89 207.235 213.89C206.167 213.89 205.295 214.758 205.291 215.828C205.287 216.901 206.156 217.777 207.227 217.78Z"
        fill="#404851"
      />
      <g opacity="0.4">
        <path
          opacity="0.4"
          d="M205.865 215.588C206.233 215.223 206.718 215.022 207.235 215.022C207.237 215.022 207.24 215.022 207.243 215.022L246.724 215.169C247.243 215.171 247.73 215.375 248.096 215.744C248.322 215.973 248.476 216.25 248.567 216.548C248.623 216.368 248.66 216.182 248.661 215.989C248.662 215.469 248.462 214.98 248.096 214.611C247.73 214.242 247.242 214.038 246.724 214.036L207.243 213.889C207.24 213.889 207.237 213.889 207.235 213.889C206.718 213.889 206.232 214.09 205.865 214.455C205.497 214.821 205.293 215.309 205.291 215.828C205.29 216.027 205.328 216.218 205.384 216.401C205.476 216.098 205.634 215.817 205.865 215.588Z"
          fill="white"
        />
      </g>
      <path
        d="M246.434 177.363H206.514V199.392H246.434V177.363Z"
        fill="#404851"
      />
      <path
        d="M246.434 200.148H206.513C206.097 200.148 205.759 199.81 205.759 199.393V177.363C205.759 176.947 206.097 176.608 206.513 176.608H246.434C246.85 176.608 247.188 176.947 247.188 177.363V199.393C247.188 199.81 246.85 200.148 246.434 200.148ZM207.268 198.638H245.679V178.119H207.268V198.638V198.638Z"
        fill="#404851"
      />
      <g opacity="0.4">
        <path
          opacity="0.4"
          d="M245.68 178.118H207.268V179.25H245.68V178.118Z"
          fill="white"
        />
      </g>
      <path
        d="M222.798 191.016C222.809 191.012 222.819 191.004 222.83 191.003C222.921 190.993 223.373 190.754 223.823 190.413C224.285 190.071 224.795 189.625 225.183 189.19C225.329 189.025 225.458 188.862 225.559 188.714C225.917 188.184 226.053 187.605 226.231 186.932C226.409 186.267 226.632 185.505 227.241 184.756C227.266 184.725 227.296 184.688 227.329 184.649C227.823 184.099 228.394 183.872 228.893 183.646C229.108 183.548 229.315 183.45 229.519 183.333C229.062 183.109 228.532 183.015 227.971 183.047C226.654 183.122 225.154 183.88 223.972 185.206C222.255 187.134 221.799 189.589 222.798 191.016Z"
        fill="white"
      />
      <path
        d="M231.176 188.385C231.262 188.132 231.328 187.884 231.377 187.635C231.439 187.311 231.466 186.991 231.46 186.684C231.442 185.888 231.191 185.177 230.696 184.655C230.316 184.922 229.943 185.097 229.62 185.242C229.092 185.474 228.706 185.647 228.405 185.988C228.39 186.005 228.372 186.027 228.35 186.056C227.884 186.629 227.707 187.2 227.533 187.848C227.363 188.491 227.209 189.211 226.72 189.937C226.586 190.136 226.428 190.333 226.255 190.526C225.803 191.034 225.248 191.516 224.734 191.892C224.423 192.117 224.145 192.3 223.889 192.438C224.414 192.804 225.063 192.959 225.767 192.919C227.074 192.845 228.558 192.097 229.736 190.791C229.746 190.78 229.756 190.768 229.766 190.76C230.426 190.019 230.9 189.195 231.176 188.385Z"
        fill="white"
      />
      <g opacity="0.2">
        <path
          opacity="0.2"
          d="M234.713 155.635C234.713 155.635 230.94 161.297 210.569 160.543H243.767V157.814L241.546 155.592L234.713 155.635Z"
          fill="#404851"
        />
      </g>
      <g opacity="0.2">
        <path
          opacity="0.2"
          d="M235.287 161.558C235.287 161.558 227.289 166.677 206.103 165.308L206.043 166.961H247.916C247.916 166.961 249.048 163.185 244.144 161.675C244.143 161.675 235.287 161.373 235.287 161.558Z"
          fill="#404851"
        />
      </g>
      <g opacity="0.2">
        <path
          opacity="0.2"
          d="M209.438 169.982L235.056 170.665C236.579 170.706 237.785 171.974 237.738 173.498C237.493 181.473 234.842 204.282 212.833 209.246L213.211 212.266H240.372L245.276 168.094H209.061L209.438 169.982Z"
          fill="#404851"
        />
      </g>
      <g opacity="0.2">
        <path
          opacity="0.2"
          d="M212.079 199.807L212.456 200.939L241.783 202.417L242.049 199.409L212.079 199.807Z"
          fill="#404851"
        />
      </g>
      <g opacity="0.2">
        <path
          opacity="0.2"
          d="M237.73 213.021C237.73 213.021 236.222 217.929 212.001 217.692L210.947 219.061L247.916 218.683L250.18 216.795L249.049 213.775L237.73 213.021Z"
          fill="#404851"
        />
      </g>
      <g opacity="0.2">
        <path
          opacity="0.2"
          d="M78.7463 199.212V188.029C78.7463 185.555 76.7347 183.541 74.2625 183.541H68.9225V206.222H59.6385C58.909 206.222 58.3184 206.814 58.3184 207.543V208.846C58.3184 213.286 60.8396 217.146 64.5232 219.074C72.7846 216.257 78.7463 208.42 78.7463 199.212Z"
          fill="#404851"
        />
      </g>
      <g opacity="0.2">
        <path
          opacity="0.2"
          d="M68.9228 181.758C69.2608 181.19 69.5755 180.602 69.8618 179.995L72.1226 180.931L70.3378 178.903C70.8534 177.632 71.2561 176.292 71.5311 174.896L75.1406 174.96L71.7295 173.743C71.8821 172.679 71.9649 171.59 71.9649 170.478C71.9649 169.916 71.939 169.361 71.8993 168.811L75.1406 166.962L71.7777 167.573C71.5941 166.13 71.2759 164.733 70.837 163.404C74.0136 162.402 77.0117 159.88 78.8432 156.274C82.0198 150.018 80.503 142.842 75.4631 140.279C74.3887 139.733 73.2298 139.429 72.0304 139.366L71.3673 136.382L70.6982 139.396C70.1101 139.451 69.516 139.565 68.9219 139.73V181.758H68.9228Z"
          fill="#404851"
        />
      </g>
      <g opacity="0.2">
        <path
          opacity="0.2"
          d="M229.568 208.846V207.543C229.568 206.813 228.977 206.222 228.248 206.222H218.964V155.353L213.828 155.558C211.63 155.646 209.901 157.44 209.893 159.642L209.889 160.521C208.607 160.706 207.42 161.288 206.483 162.218C205.331 163.363 204.693 164.889 204.687 166.514L204.684 167.196C204.683 167.497 204.801 167.786 205.012 167.999C205.224 168.212 205.511 168.333 205.812 168.334L208.004 168.341L211.783 211.642L207.249 211.625C207.244 211.625 207.239 211.625 207.234 211.625C206.116 211.625 205.064 212.058 204.27 212.847C203.472 213.639 203.031 214.695 203.027 215.82C203.022 216.944 203.456 218.003 204.248 218.801C205.039 219.599 206.095 220.041 207.218 220.046L220.587 220.096C225.722 218.932 229.568 214.331 229.568 208.846Z"
          fill="#404851"
        />
      </g>
      <path
        d="M212.359 219.061H74.7655V131.325C74.7655 126.96 78.3017 123.421 82.6639 123.421H204.461C208.823 123.421 212.359 126.96 212.359 131.325V219.061V219.061Z"
        fill="#EBEBEB"
      />
      <path
        d="M212.36 220.383H74.7661C74.0367 220.383 73.446 219.791 73.446 219.062V131.326C73.446 126.239 77.5815 122.1 82.6645 122.1H204.462C209.545 122.1 213.68 126.239 213.68 131.326V219.062C213.68 219.791 213.089 220.383 212.36 220.383ZM76.0863 217.74H211.039V131.325C211.039 127.695 208.088 124.742 204.461 124.742H82.6645C79.037 124.742 76.0863 127.695 76.0863 131.325V217.74Z"
        fill="#404851"
      />
      <g opacity="0.4">
        <path
          opacity="0.4"
          d="M78.352 133.213C78.352 129.583 81.3026 126.63 84.9302 126.63H206.726C207.793 126.63 208.797 126.891 209.689 127.344C208.486 125.766 206.594 124.743 204.463 124.743H82.6659C79.0383 124.743 76.0876 127.696 76.0876 131.326V217.741H78.3511V133.213H78.352Z"
          fill="white"
        />
      </g>
      <g opacity="0.4">
        <path
          opacity="0.4"
          d="M202.269 131.85H87.8751C85.2909 131.85 83.1887 133.942 83.1887 136.512V213.625C83.1887 214.251 83.6949 214.757 84.32 214.757C84.9452 214.757 85.4513 214.251 85.4513 213.625H204.692C204.692 214.251 205.198 214.757 205.823 214.757C206.448 214.757 206.954 214.251 206.954 213.625V136.512C206.956 133.942 204.853 131.85 202.269 131.85Z"
          fill="white"
        />
      </g>
      <path
        d="M82.8121 213.626V136.513C82.8121 134.564 84.4039 132.983 86.3673 132.983H200.761C202.724 132.983 204.316 134.564 204.316 136.513V213.626"
        fill="#F9F9F9"
      />
      <path
        d="M204.316 214.758C203.691 214.758 203.185 214.252 203.185 213.626V136.513C203.185 135.191 202.097 134.116 200.761 134.116H86.3671C85.0306 134.116 83.9433 135.192 83.9433 136.513V213.626C83.9433 214.252 83.4362 214.758 82.812 214.758C82.1877 214.758 81.6807 214.252 81.6807 213.626V136.513C81.6807 133.943 83.7829 131.851 86.3679 131.851H200.762C203.346 131.851 205.449 133.943 205.449 136.513V213.626C205.448 214.252 204.941 214.758 204.316 214.758Z"
        fill="#404851"
      />
      <g opacity="0.2">
        <path
          opacity="0.2"
          d="M87.716 140.666C87.716 138.716 89.3078 137.135 91.2712 137.135H204.316V136.513C204.316 134.564 202.724 132.983 200.761 132.983H86.3666C84.4032 132.983 82.8115 134.564 82.8115 136.513V213.626H87.716V140.666Z"
          fill="#404851"
        />
      </g>
      <g opacity="0.15">
        <path
          opacity="0.15"
          d="M204.531 177.91C204.169 179.085 204.153 209.623 82.6819 202.45V206.446H203.965L204.531 177.91Z"
          fill="#404851"
        />
      </g>
      <path
        d="M212.756 219.061H74.3691C68.7316 219.061 64.1624 214.487 64.1624 208.846V207.543H222.964V208.846C222.964 214.488 218.394 219.061 212.756 219.061Z"
        fill="#EBEBEB"
      />
      <path
        d="M212.756 220.383H74.3689C68.0123 220.383 62.8412 215.208 62.8412 208.846V207.543C62.8412 206.813 63.4328 206.222 64.1614 206.222H222.963C223.692 206.222 224.283 206.814 224.283 207.543V208.846C224.284 215.208 219.113 220.383 212.756 220.383ZM65.4824 208.864C65.4919 213.76 69.4747 217.74 74.3689 217.74H212.756C217.65 217.74 221.633 213.76 221.642 208.864H65.4824Z"
        fill="#404851"
      />
      <g opacity="0.4">
        <path
          opacity="0.4"
          d="M68.8776 211.13H221.345C221.538 210.406 221.642 209.647 221.643 208.864H65.4828C65.4906 212.674 67.905 215.928 71.2816 217.185C69.7959 215.599 68.8828 213.469 68.8776 211.13Z"
          fill="white"
        />
      </g>
      <path
        d="M199.429 215.411C198.909 215.411 198.486 214.988 198.486 214.467V210.843C198.486 210.322 198.909 209.899 199.429 209.899C199.95 209.899 200.373 210.322 200.373 210.843V214.467C200.372 214.988 199.95 215.411 199.429 215.411Z"
        fill="#404851"
      />
      <path
        d="M203.438 215.54C202.917 215.54 202.495 215.117 202.495 214.596V210.973C202.495 210.451 202.917 210.029 203.438 210.029C203.959 210.029 204.381 210.451 204.381 210.973V214.596C204.381 215.117 203.959 215.54 203.438 215.54Z"
        fill="#404851"
      />
      <path
        d="M207.446 215.67C206.926 215.67 206.503 215.247 206.503 214.726V211.102C206.503 210.581 206.926 210.158 207.446 210.158C207.967 210.158 208.39 210.581 208.39 211.102V214.726C208.39 215.247 207.967 215.67 207.446 215.67Z"
        fill="#404851"
      />
      <path
        d="M157.967 212.332H129.158C126.972 212.332 125.199 210.558 125.199 208.37V207.543H161.925V208.37C161.925 210.557 160.153 212.332 157.967 212.332Z"
        fill="#D0D0D0"
      />
      <path
        d="M157.967 213.276H129.158C126.455 213.276 124.256 211.075 124.256 208.37V207.543C124.256 207.022 124.678 206.599 125.199 206.599H161.926C162.447 206.599 162.869 207.022 162.869 207.543V208.37C162.869 211.074 160.67 213.276 157.967 213.276ZM126.145 208.487C126.207 210.098 127.535 211.388 129.158 211.388H157.967C159.591 211.388 160.919 210.097 160.981 208.487H126.145Z"
        fill="#404851"
      />
      <g opacity="0.2">
        <path
          opacity="0.2"
          d="M157.969 212.332H129.16C126.974 212.332 125.201 210.558 125.201 208.37V207.543H161.927V208.37C161.927 210.557 160.155 212.332 157.969 212.332Z"
          fill="#404851"
        />
      </g>
      <path
        d="M96.7493 213.276H78.3864C77.8656 213.276 77.4431 212.853 77.4431 212.332C77.4431 211.811 77.8656 211.388 78.3864 211.388H96.7493C97.2701 211.388 97.6926 211.811 97.6926 212.332C97.6926 212.853 97.2701 213.276 96.7493 213.276Z"
        fill="#404851"
      />
      <path
        d="M111.342 160.754C111.342 160.754 120.849 168.886 130.273 159.664C130.273 159.664 131.057 165.513 123.733 167.961C121.652 168.656 119.336 168.605 117.265 167.787C114.75 166.796 111.705 164.774 111.342 160.754Z"
        fill="#404851"
      />
      <path
        d="M156.832 160.754C156.832 160.754 166.339 168.886 175.762 159.664C175.762 159.664 176.546 165.513 169.223 167.961C167.142 168.656 164.826 168.605 162.754 167.787C160.239 166.796 157.195 164.774 156.832 160.754Z"
        fill="#404851"
      />
      <path
        d="M152.236 191.83C152.236 191.83 142.728 183.699 133.305 192.92C133.305 192.92 132.521 187.071 139.844 184.624C141.926 183.928 144.242 183.98 146.313 184.797C148.828 185.789 151.873 187.811 152.236 191.83Z"
        fill="#404851"
      />
      <g opacity="0.2">
        <path
          opacity="0.2"
          d="M152.094 207.358C152.094 207.358 147.19 211.888 126.442 210.378L127.477 211.928H158.319C158.319 211.928 161.903 211.133 161.903 207.358H152.094Z"
          fill="#404851"
        />
      </g>
      <g opacity="0.2">
        <path
          opacity="0.2"
          d="M203.023 207.169C203.023 207.169 178.313 218.872 66.461 214.909L70.8448 218.264H216.477L221.754 214.341L222.827 207.546L203.023 207.169Z"
          fill="#404851"
        />
      </g>
      <path
        d="M256.807 220.383H27.606C26.8765 220.383 26.2858 219.791 26.2858 219.062C26.2858 218.333 26.8773 217.741 27.606 217.741H256.807C257.536 217.741 258.127 218.333 258.127 219.062C258.127 219.791 257.536 220.383 256.807 220.383Z"
        fill="#404851"
      />
      <path
        d="M148.585 84.783H143.524C142.876 84.783 142.109 84.4232 142.109 83.4153C142.109 82.4073 142.876 82.0466 143.524 82.0466H151.847C152.781 82.0466 153.286 82.6705 153.286 83.5827C153.286 83.9667 153.069 84.399 152.734 84.7589L146.258 91.8635H152.015C152.662 91.8635 153.43 92.2233 153.43 93.2313C153.43 94.2392 152.662 94.5999 152.015 94.5999H143.093C142.062 94.5999 141.534 93.9277 141.534 93.2313C141.534 92.7273 141.678 92.295 141.99 91.9593L148.585 84.783Z"
        fill="#404851"
      />
      <path
        d="M180.517 71.3098H173.953C173.114 71.3098 172.118 70.8429 172.118 69.5356C172.118 68.2282 173.114 67.7614 173.953 67.7614H184.747C185.96 67.7614 186.614 68.5708 186.614 69.7539C186.614 70.2518 186.334 70.8127 185.898 71.2796L177.499 80.495H184.964C185.804 80.495 186.799 80.9618 186.799 82.2692C186.799 83.5766 185.804 84.0434 184.964 84.0434H173.393C172.056 84.0434 171.371 83.1718 171.371 82.2692C171.371 81.6151 171.557 81.055 171.962 80.6192L180.517 71.3098Z"
        fill="#404851"
      />
      <path
        d="M166.584 100.892H162.111C161.538 100.892 160.86 100.573 160.86 99.6827C160.86 98.7922 161.539 98.4738 162.111 98.4738H169.467C170.294 98.4738 170.739 99.0252 170.739 99.8312C170.739 100.17 170.547 100.553 170.25 100.871L164.527 107.151H169.614C170.187 107.151 170.864 107.469 170.864 108.36C170.864 109.251 170.186 109.569 169.614 109.569H161.728C160.816 109.569 160.35 108.975 160.35 108.36C160.35 107.914 160.478 107.532 160.753 107.235L166.584 100.892Z"
        fill="#404851"
      />
      <path
        d="M18.226 187.952C19.3799 187.952 20.3153 187.016 20.3153 185.861C20.3153 184.706 19.3799 183.77 18.226 183.77C17.0721 183.77 16.1367 184.706 16.1367 185.861C16.1367 187.016 17.0721 187.952 18.226 187.952Z"
        fill="#404851"
      />
      <path
        d="M258.949 197.769C260.28 197.769 261.359 196.69 261.359 195.358C261.359 194.027 260.28 192.947 258.949 192.947C257.619 192.947 256.54 194.027 256.54 195.358C256.54 196.69 257.619 197.769 258.949 197.769Z"
        fill="#404851"
      />
      <path
        d="M236.358 84.8946C237.468 84.8946 238.368 83.994 238.368 82.8831C238.368 81.7722 237.468 80.8716 236.358 80.8716C235.248 80.8716 234.348 81.7722 234.348 82.8831C234.348 83.994 235.248 84.8946 236.358 84.8946Z"
        fill="#404851"
      />
      <path
        d="M225.434 68.35C225.899 67.8849 225.606 66.7812 224.785 65.5299C224.541 65.158 224.541 64.6791 224.785 64.3072C225.606 63.0559 225.899 61.9522 225.434 61.4871C224.969 61.0219 223.867 61.3153 222.616 62.1369C222.245 62.3811 221.766 62.3811 221.395 62.1369C220.144 61.3153 219.041 61.0219 218.577 61.4871C218.112 61.9522 218.405 63.0559 219.226 64.3072C219.47 64.6791 219.47 65.158 219.226 65.5299C218.405 66.7812 218.112 67.8849 218.577 68.35C219.041 68.8152 220.144 68.5218 221.395 67.7003C221.766 67.456 222.245 67.456 222.616 67.7003C223.867 68.5218 224.969 68.8152 225.434 68.35Z"
        fill="#404851"
      />
      <path
        d="M8.41471 173.182C8.94932 173.182 9.41495 172.378 9.66155 171.186C9.73485 170.831 10.0108 170.556 10.3643 170.482C11.5551 170.235 12.3587 169.769 12.3587 169.234C12.3587 168.7 11.556 168.233 10.3643 167.987C10.0099 167.913 9.73485 167.637 9.66155 167.283C9.41495 166.092 8.94846 165.287 8.41471 165.287C7.88097 165.287 7.41448 166.091 7.16788 167.283C7.09458 167.638 6.81866 167.913 6.46513 167.987C5.27434 168.233 4.4707 168.7 4.4707 169.234C4.4707 169.769 5.27347 170.235 6.46513 170.482C6.81952 170.556 7.09458 170.832 7.16788 171.186C7.41448 172.378 7.88011 173.182 8.41471 173.182Z"
        fill="#404851"
      />
      <path
        d="M94.7184 80.0206C96.4781 80.0206 97.9046 78.593 97.9046 76.832C97.9046 75.071 96.4781 73.6434 94.7184 73.6434C92.9588 73.6434 91.5323 75.071 91.5323 76.832C91.5323 78.593 92.9588 80.0206 94.7184 80.0206Z"
        fill="#404851"
      />
      <path
        d="M76.2878 93.2987C77.4379 93.2987 78.3702 92.3656 78.3702 91.2147C78.3702 90.0637 77.4379 89.1306 76.2878 89.1306C75.1378 89.1306 74.2054 90.0637 74.2054 91.2147C74.2054 92.3656 75.1378 93.2987 76.2878 93.2987Z"
        fill="#404851"
      />
    </BaseIcon>
  );
};

export default ComputerSleepIcon;
